export const hasKey = <K extends string>(
  key: K,
  object: unknown
): object is Record<K, unknown> => {
  return typeof object === 'object' && object !== null && key in object;
};
